// extracted by mini-css-extract-plugin
module.exports = {"message":"ValidationMessage_message__2ZmU5"};